import { extractExcelPreview } from "./excel";
import { extractPdfPreview } from "./pdf";
import { extractPlainPreview } from "./plain";

export type FileFormat = "pdf" | "excel" | "csv" | "docx" | "plain" | "image" | "unknown";

export function detectFormat(file: File): FileFormat {
  const name = file.name.toLowerCase();
  const type = (file.type || "").toLowerCase();
  if (name.endsWith(".pdf") || type === "application/pdf") return "pdf";
  if (/\.(xlsx|xls|xlsm|xlsb)$/.test(name) || type.includes("spreadsheet") || type.includes("excel")) return "excel";
  if (name.endsWith(".csv") || type === "text/csv") return "csv";
  if (name.endsWith(".docx") || name.endsWith(".doc") || type.includes("word")) return "docx";
  if (/\.(txt|md|log|json|tsv)$/.test(name) || type.startsWith("text/")) return "plain";
  if (type.startsWith("image/")) return "image";
  return "unknown";
}

/**
 * Extract a short text snippet from the file for IRL matching.
 *
 * For unsupported formats (docx, image, unknown), returns an empty string —
 * the matcher then falls back to filename-only matching on the backend.
 * Word doc support is intentionally deferred (would add `mammoth` as a dep).
 */
export async function extractPreview(file: File, format: FileFormat): Promise<string> {
  switch (format) {
    case "pdf":
      return extractPdfPreview(file);
    case "excel":
      return extractExcelPreview(file);
    case "csv":
    case "plain":
      return extractPlainPreview(file);
    default:
      return "";
  }
}
